export const brandNames = {
  otis: 'otis',
  momentum: 'momentum',
  pepper: 'pepper',
  visi: 'visi',
  geeni: 'geeni',
  notion: 'notion',
};
